export enum UrlFetchStatus {
    NOT_FETCHED = 'NOT_FETCHED',
    TO_FETCH = 'TO_FETCH',
    IN_PROGRESS = 'IN_PROGRESS',
    FETCHED = 'FETCHED',
    FAILED = 'FAILED',
}

export default UrlFetchStatus;
